import { getNavigationUrl } from '../../../utils';
import { Row } from 'common/styles';
import { Widget } from '../../../apiService';
import Carousel from '../../../Carousel';
import BundleCard from '../../../BundleCard';

const FranchiseWidget = ({ widget }: { widget: Widget<'franchise'> }) => {
  const {
    id,
    configuration: { items, navigation_configuration },
    display_title,
  } = widget;
  const more = getNavigationUrl(navigation_configuration, undefined, undefined, id);

  return (
    <Carousel m={0} title={display_title} more={more}>
      <Row id={id} cols={{ xs: 2, sm: 3, md: 4, lg: 6 }}>
        {items.map(({ video_content, english_name, persian_name, image }, i) => (
          <BundleCard
            key={video_content?.short_id || i}
            video_content={video_content}
            english_name={english_name}
            persian_name={persian_name}
            image={image}
          />
        ))}
      </Row>
    </Carousel>
  );
};

export default FranchiseWidget;
